import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const watchWorkstationStatus = unaryStreamRpc({
  name: "watchWorkstationStatus",
  input: z.object({ workstationId: z.string() }),
  output: z.object({ online: z.boolean() }),
});
